<template>
  <div id="app">
    <HeadMenu></HeadMenu>
    <router-view/>
    <TestDrive></TestDrive>
    <Foot></Foot>
    <policy-bottom></policy-bottom>
    <policy-modal></policy-modal>
  </div>
</template>

<script>
  import HeadMenu from '@/components/common/HeadMenu'
  import Foot from '@/components/common/Foot'
  import TestDrive from '@/components/common/TestDrive'
  import PolicyBottom from '@/components/common/PolicyBottom'
  import PolicyModal from '@/components/common/PolicyModal'
  import api from './util/api.js'
  export default {
    name: 'App',
    components: {
      HeadMenu,
      Foot,
      TestDrive,
      PolicyBottom,
      PolicyModal
    },
    data() {
      return {
        scrolled: false,
        fixedTop: false
      }
    },
    methods: {
      indexInit() {
        const $hgl = document.getElementsByClassName('header-gl').item(0);
        // const $hge = document.getElementById('header-ds');
        const $hge = document.getElementById('search') || document.getElementById('header-ds');
        const index = document.getElementsByClassName('index').item(0);
        if (index) index.style.paddingTop = $hge.offsetHeight + $hgl.offsetHeight + 'px';
      },
      handleScroll() {
        this.scrolled = window.scrollY > 0;
        const st = document.documentElement.scrollTop || document.body.scrollTop;
        const $hgl = document.getElementsByClassName('header-gl').item(0);
        // const $hge = document.getElementById('header-ds');
        const $hge = document.getElementById('search') || document.getElementById('header-ds');
        const headerHeight = $hgl.offsetHeight;
        if ($hgl && $hge) {
          this.indexInit();
          if (st > headerHeight) {
            if (!this.fixedTop) {
              window.snabbt($hgl,{
                position: [0, -headerHeight, 0],
                duration: 200
              });
              window.snabbt($hge,{
                position: [0, -headerHeight, 0],
                delay: 150,
                duration: 200
              });
              this.fixedTop = true;
            }
          } else {
            if (this.fixedTop) {
              window.snabbt($hgl,{
                position: [0, 0, 0],
                duration: 200
              });
              window.snabbt($hge,{
                position: [0, 0, 0],
                duration: 200
              });
              this.fixedTop = false;
            }
          }
        } else {
          window.snabbt($hgl,{
            position: [0, 0, 0],
            duration: 200
          });
          this.fixedTop = false;
        }
      },
      fetchPolicyCookie () {
        api.policy.queryAgreeCookie().then(({data}) => {
          this.$store.commit('changeCookie',{bool: data.data})
        })
	  }

	},

    mounted() {
      this.fetchPolicyCookie()
      this.indexInit();
      window.addEventListener('scroll', this.debounce(this.handleScroll,10));
      if(window.SCBeacon) {
        window.SCBeacon.trackGoal('G_MALL_HOME_LOADED');
      }
    },
    updated() {
      this.indexInit();
    }
  }
</script>
<style lang="less">
  @buleColor1: rgb(28, 40, 54);
  *, *::before, *::after {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  html {
	font-size: 100px;
	color:#333;
    body{
      /*padding-top: .9rem;*/
    }
  }
   html.noscroll{
    height:100%;
    overflow:hidden;
  }

  #header {
    .navbar.navbar-default {
      background-color: @buleColor1;
    }
    > .navbar {
      margin-bottom: 0;
    }
    #header-menulist {
      text-align: center;
      .nav.navbar-nav {
        display: inline-block;
        float: none;
        vertical-align: middle;
      }
    }
  }
  
  li {
    list-style: none;
  }

  .topBread {
    font-size: 0.18rem;
    padding: 0.2rem 0.5rem;
    .breadcrumb {
      background-color: rgba(0, 0, 0, 0);
      margin-bottom: 0;
      > li + li:before {
        content: "";
        padding: 0;
      }
    }
  }

  .must {
    margin-right: 0.1rem;
    color: red;
  }
  .form-control {
    border-radius: 5px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .select2-container--default .select2-selection--single {
    border-radius: 2px;
    border: 1px solid #ccc;
  }

  .select2-container .select2-selection--single {
    height: 34px;
  }

  .select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 34px;
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 32px;
  }

  .form-group1 {
    > div {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      padding: 0;
      margin-left: 0;
      margin-bottom: 15px;
      [class*=col-] {
        padding: 0;
      }
      .col-sm-6 {
        width: calc(~"50% - 0.1rem");
        &:first-child {
          margin-left: -0.2rem;
        }
        &:last-child {
          margin-right: -0.2rem;
        }
      }
    }
  }

  .waitMask {
    width: 100%;
    height: 100%;
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    background-color: rgba(225, 225, 225, 0.8);
    .waitBlock {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .waitText {
        font-weight: bold;
        color: #262a33;
        display: inline-block;
        vertical-align: middle;
        font-size: 0.24rem;
      }
      .waitImg {
        display: inline-block;
        margin-right: 0.1rem;
      }
    }
  }

  .eva-star {
    width: 100%;
    padding-left: 0;
    margin-bottom: 0;
    li {
      display: inline-block;
      span {
        color: #ddd;
        font-size: 0.16rem;
      }
      &.active {
        span {
          color: rgb(253, 170, 1);
        }
      }
    }
  }

  .love {
    cursor: pointer;
    user-select: none;
    &.active {
      color: red;
      animation: love-scale 1s;
      &:before{
        content: "\e604";
      }
    }
  }

  @keyframes love-scale {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }

  .pagationBlock {
    text-align: right;
  }
  figure {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  figure img {
    width: 1050px;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(125, 125, 125, 0.7);
    -webkit-border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(125, 125, 125, 0.7);
    -webkit-border-radius: 6px;
  }
</style>
<style lang="less">
.flex {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
}
.justify-start {
	justify-content: flex-start;
}
.justify-center {
	justify-content: center;
}
.justify-end {
	justify-content: flex-end;
}
.justify-space-between {
	justify-content: space-between;
}
.justify-space-around {
	justify-content: space-around;
}
.justify-space-evenly {
	justify-content: space-evenly;
}
.align-start {
	align-items: flex-start;
}
.align-center {
	align-items: center;
}
.align-end{
	align-items: flex-end;
}
.flex-1 {
	flex: 1;
}
.center {
	text-align: center;
}
.left {
	text-align: left;
}
.right {
	text-align: right;
}
.lh-1{
	line-height: 1;
}
.cm-btn {
	cursor: pointer;
	user-select: none;
	transition: 0.3s;
	&:hover {
		filter: brightness(1.1);
	}
	&:active {
		filter: brightness(0.9);
	}
	&.disabled {
		// filter: grayscale(100%);
		color: #999 !important;
		background: #efefef !important;
		pointer-events: none;
	}
}
.btn-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue